import { DOC_IDS } from './docsData';

const DOC_LINK_PATTERNS = [
    { pattern: /architecture-details\.html$/i, id: 'architecture-details' },
    { pattern: /architecture-diagram\.html$/i, id: 'architecture-diagram' },
    { pattern: /siprec-api-gateway/i, id: 'siprec-api-gateway' },
    { pattern: /vtsl_call_recorder_api/i, id: 'vtsl_call_recorder_api' },
    { pattern: /sil-eventbus-handler/i, id: 'sil-eventbus-handler' },
    { pattern: /nats-stream-aggregator/i, id: 'nats-stream-aggregator' },
    { pattern: /vtsl-recording-eventbus-handler/i, id: 'vtsl-recording-eventbus-handler' },
    { pattern: /vtsl_silhoute/i, id: 'vtsl_silhoute' },
    { pattern: /silhoute_event_parser/i, id: 'silhoute_event_parser' },
];

export function resolveDocIdFromHref(href) {
    if (!href) {
        return null;
    }

    const pathOnly = href.split('#')[0].split('?')[0];
    if (!pathOnly) {
        return null;
    }

    for (let i = 0; i < DOC_LINK_PATTERNS.length; i += 1) {
        const item = DOC_LINK_PATTERNS[i];
        if (item.pattern.test(pathOnly) && DOC_IDS.indexOf(item.id) !== -1) {
            return item.id;
        }
    }

    return null;
}

function rewriteDocLinks(html) {
    return html.replace(
        /<a\b([^>]*?)\bhref\s*=\s*(["'])([^"']*)\2([^>]*)>/gi,
        (match, pre, quote, href, post) => {
            if (!href || href.charAt(0) === '#') {
                return match;
            }

            const docId = resolveDocIdFromHref(href);
            const hashIndex = href.indexOf('#');
            const hash = hashIndex !== -1 ? href.slice(hashIndex + 1) : '';

            if (!docId) {
                // Block any other navigation that could load the SPA inside the iframe.
                return `<a${pre}href="#"${post} data-docs-blocked="1">`;
            }

            const hashAttr = hash ? ` data-doc-hash="${hash}"` : '';
            return `<a${pre}href="#"${post} data-doc-id="${docId}"${hashAttr}>`;
        }
    );
}

export function prepareDocHtml(html) {
    const rewritten = rewriteDocLinks(html);

    const bridgeScript = `
<script>
(function () {
  function postNavigate(docId, hash) {
    if (!docId) return;
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({
        source: 'vtsl-docs',
        type: 'navigate',
        docId: docId,
        hash: hash || ''
      }, '*');
    }
  }

  document.addEventListener('click', function (event) {
    var anchor = event.target;
    while (anchor && anchor.tagName !== 'A') {
      anchor = anchor.parentElement;
    }
    if (!anchor) return;

    var docId = anchor.getAttribute('data-doc-id');
    if (docId) {
      event.preventDefault();
      event.stopPropagation();
      postNavigate(docId, anchor.getAttribute('data-doc-hash') || '');
      return;
    }

    if (anchor.getAttribute('data-docs-blocked') === '1') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var href = anchor.getAttribute('href');
    if (!href) return;

    // In-page anchors (#cards, etc.) — scroll manually for reliability in srcdoc.
    if (href.charAt(0) === '#') {
      var targetId = href.slice(1);
      if (!targetId) return;
      var target = document.getElementById(targetId);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    // Safety net: never let the iframe navigate to the host app.
    event.preventDefault();
    event.stopPropagation();
  }, true);
})();
</script>`;

    let nextHtml = rewritten;

    if (/<\/body>/i.test(nextHtml)) {
        return nextHtml.replace(/<\/body>/i, bridgeScript + '</body>');
    }

    return nextHtml + bridgeScript;
}
